import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

function BlogDetail() {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/blogs/${id}`)
            .then((res) => {
                setBlog(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error loading blog:", err);
                setLoading(false);
            });
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (!blog) return <p>Blog not found.</p>;

    return (
        <div style={{ padding: "20px" }}>
            <Link to="/">← Back to Blogs</Link>
            <h1>{blog.title}</h1>
            <p>{blog.content}</p>
            <p style={{ fontSize: "0.9em", color: "#666" }}>
                Posted on: {blog.createdAt?.toDate?.().toLocaleString?.() || "Unknown"}
            </p>
        </div>
    );
}

export default BlogDetail;